import React, { ReactNode } from "react";
import { Card } from "@UI/Components/Card/Card";
import { Text } from "@UI/Components/Text/Text";
import { Flex } from "@UI/Components/Flex/Flex";
import { Icon } from "@UI/Components/Icon/Icon";
import { ArrowsRotate } from "@UI/Components/Icons/ArrowsRotate";
import { Ban } from "@UI/Components/Icons/Ban";
import { Check } from "@UI/Components/Icons/Check";
import { PaperPlane } from "@UI/Components/Icons/PaperPlane";
import { Suitcase } from "@UI/Components/Icons/Suitcase";
import { UserIcon } from "@UI/Components/Icons/UserIcon";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import messages from "./messages";

export interface ITrackingCard {
  type: "score" | "recurrent_client" | "total_clients" | "selectionsCount" | "offersSentCount" | "closedServices" | "cancelledServices" | "recurrentClients" | "totalClients" | "totalServices";
  value: number | ReactNode;
  valueSubInfos?: ReactNode;
  valueExplanation?: ReactNode;
}

const TYPE_ICONS: Partial<Record<ITrackingCard["type"], React.ElementType>> = {
  selectionsCount: Check,
  offersSentCount: PaperPlane,
  closedServices: Suitcase,
  cancelledServices: Ban,
  recurrentClients: ArrowsRotate,
  totalClients: UserIcon,
  totalServices: Suitcase,
};

export const SingleTrackingCard = ({
  type,
  value,
  valueSubInfos,
  valueExplanation,
}: ITrackingCard) => {
  const TypeIcon = TYPE_ICONS[type];

  return (
    <Card w="full" p={{ base: 4, md: 5 }} h="auto">
      <Flex flexDirection="column">
        <Text
          as="span"
          fontWeight={400}
          fontSize={{ base: "sm", md: "md" }}
        >
          <FormattedMessage {...messages[type]} />
        </Text>
        <Flex alignItems="center" gap={2}>
          {TypeIcon && (
            <Icon as={TypeIcon} boxSize={{ base: "20px", md: "26px" }} color="#666666" />
          )}
          <Text
            as="span"
            fontWeight={700}
            color="black"
            fontSize={{ base: "xl", md: "3xl" }}
          >
            {value}
          </Text>
        </Flex>
        {valueExplanation && (
          <Text as="span" fontSize={{ base: "xs", md: "sm" }} color="#666666">
            {valueExplanation}
          </Text>
        )}
        <Text as="span" fontWeight={700} color="black">
          {valueSubInfos}
        </Text>
      </Flex>
    </Card>
  );
};
